import localForage from 'localforage';

const localforage = localForage.createInstance({
    driver: [localForage.INDEXEDDB,
        localForage.WEBSQL,
        localForage.LOCALSTORAGE],
    name: 'Matera-Clock',
    storeName: 'Matera_Clock'
});

export default localforage;

/*
export const firebaseStorage = localForage.createInstance({
    driver: [localForage.INDEXEDDB,
        localForage.WEBSQL,
        localForage.LOCALSTORAGE],
    name: 'firebaseLocalStorageDb',
    storeName: 'firebaseLocalStorage'
});*/
